/**
 * Utilitários compartilhados de paginação URL (?p=&s=) entre TableV2 e ExpandableTableV2.
 */

export const readPaginationFromSearch = (search, defaultPageSize) => {
  const q = new URLSearchParams(search);
  const pRaw = q.get('p');
  const sRaw = q.get('s');
  const p =
    pRaw != null && pRaw !== '' && Number.isFinite(Number(pRaw))
      ? Math.max(0, Number(pRaw))
      : 0;
  const s =
    sRaw != null && sRaw !== '' && Number.isFinite(Number(sRaw))
      ? Math.max(1, Number(sRaw))
      : defaultPageSize;
  return { page: p, pageSize: s };
};

/** Só reescreve `?p=&s=` na listagem — não em pathname diferente (página cheia). */
export const isOnPaginationBase = (pathname, paginationBase) =>
  pathname === paginationBase;

export const ensurePaginationInUrl = (history, paginationBase, search, pageSize) => {
  const q = new URLSearchParams(search);
  const missingP = !q.get('p') || q.get('p') === '';
  const missingS = !q.get('s') || q.get('s') === '';
  if (!missingP && !missingS) return;

  const next = new URLSearchParams(search);
  if (missingP) {
    next.set('p', '0');
  }
  if (missingS) {
    next.set('s', String(pageSize));
  }
  history.replace(`${paginationBase}?${next.toString()}`);
};

export const resetPageOnFilterChange = (
  history,
  paginationBase,
  search,
  pageSizeState,
  pageSize
) => {
  const next = new URLSearchParams(search);
  const sVal =
    next.get('s') && next.get('s') !== ''
      ? next.get('s')
      : String(pageSizeState || pageSize);
  next.set('p', '0');
  next.set('s', sVal);
  history.push(`${paginationBase}?${next.toString()}`);
};

export const pushPaginationToUrl = (history, paginationBase, search, page, pageSize) => {
  const next = new URLSearchParams(search);
  next.set('p', String(page));
  next.set('s', String(pageSize));
  history.push(`${paginationBase}?${next.toString()}`);
};
